<template>
  <div class="data-page">
    <div class="data-page-header">
      <el-form inline>
        <el-form-item :label="$t('performance-board::shopName')">
          <el-select
            v-model="selectedShop"
            filterable
            :popperAppendToBody="false"
            :placeholder="$t('system::common::select_placeholder')"
            @change="changeShop()"
          >
            <el-option
              v-for="item in shopList"
              :key="item.shopId"
              :label="item.shopName"
              :value="item.shopId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('performance-board::orderDate')">
          <el-date-picker
            style="width: 260px"
            :appendToBody="false"
            :clearable="false"
            @change="handlerDateChange"
            v-model="date"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span class="header-tip">{{ $t('performance-board::data::tip') }}</span>
    </div>

    <!-- <el-card style="margin-top: 20px">

      <el-button :type="tabs === 1 ? 'primary' : ''" @click="changeShop(1)">
        {{ $t('performance-board::data::title') }}
      </el-button>
      <el-button :type="tabs === 2 ? 'primary' : ''" @click="changeShop(2)">
        {{ $t('performance-board::search::title') }}
      </el-button>
      <el-button :type="tabs === 3 ? 'primary' : ''" @click="changeShop(3)">
        {{ $t('performance-board::addBuy::title') }}
      </el-button>
      <el-row :gutter="20" class="card-content" v-if="tabs === 1">
        <el-col :lg="24" :md="24" :sm="24" :xl="24" style="color: #666666">
          <div v-html="$t('performance-board::data::tip')"></div>
        </el-col>
      </el-row>

      <el-row :gutter="20" v-show="tabs === 2">
        <el-col :lg="24" :md="24" :sm="24" :xl="24" style="margin-top: 10px; color: #666666">
          <div v-html="$t('performance-board::search::tip')"></div>
        </el-col>
        <el-col :lg="24" :md="24" :sm="24" :xl="24">
          <reportTable
            :config="searchTable"
            v-loading="loading.search"
            :style="`height: 600px;margin-top:0px;`"
            class="analysis"
          >
            <el-table-column
              prop="keyword"
              :label="$t('performance-board::search::table_keyWord')"
              min-width="130px"
              showOverflowTooltip
            ></el-table-column>
            <el-table-column
              prop="searchCnt"
              :label="$t('performance-board::search::table_searchTime')"
              min-width="130px"
            ></el-table-column>
            <el-table-column
              prop="resultNumber"
              :label="$t('performance-board::search::table_searchResult')"
              min-width="130px"
            >
              <template slot-scope="scope">{{ $dataCheck(scope.row.resultNumber) }}</template>
            </el-table-column>
            <el-table-column
              prop="proClick1"
              :label="$t('performance-board::search::table_clickOne')"
              min-width="190px"
            >
              <template slot-scope="scope">
                <div class="prodinfo--table__imgTd">
                  <el-popover placement="top-start" trigger="hover">
                    <ZImg :src="scope.row.proImg1" style="width: 250px; height: 250px"></ZImg>
                    <ZImg
                      :src="scope.row.proImg1"
                      style="width: 60px; height: 60px"
                      @click="handleToDetail(scope.row.proSpu1)"
                      slot="reference"
                    ></ZImg>
                  </el-popover>
                  <div>
                    <div>{{ $dataCheck(scope.row.proClick1) }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="proClick2"
              :label="$t('performance-board::search::table_clickTwo')"
              min-width="190px"
            >
              <template slot-scope="scope">
                <div class="prodinfo--table__imgTd">
                  <el-popover placement="top-start" trigger="hover">
                    <ZImg :src="scope.row.proImg2" style="width: 250px; height: 250px"></ZImg>
                    <ZImg
                      :src="scope.row.proImg2"
                      style="width: 60px; height: 60px"
                      @click="handleToDetail(scope.row.proSpu2)"
                      slot="reference"
                    ></ZImg>
                  </el-popover>
                  <div>
                    <div>{{ $dataCheck(scope.row.proClick2) }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="proClick3"
              :label="$t('performance-board::search::table_clickThree')"
              min-width="190px"
            >
              <template slot-scope="scope">
                <div class="prodinfo--table__imgTd">
                  <el-popover placement="top-start" trigger="hover">
                    <ZImg :src="scope.row.proImg3" style="width: 250px; height: 250px"></ZImg>
                    <ZImg
                      :src="scope.row.proImg3"
                      style="width: 60px; height: 60px"
                      @click="handleToDetail(scope.row.proSpu3)"
                      slot="reference"
                    ></ZImg>
                  </el-popover>
                  <div>
                    <div>{{ $dataCheck(scope.row.proClick3) }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </reportTable>
        </el-col>
      </el-row>

      <el-row :gutter="20" v-show="tabs === 3">
        <el-col :lg="24" :md="24" :sm="24" :xl="24" style="margin-top: 10px; color: #666666">
          <div v-html="$t('performance-board::addBuy::tip')"></div>
        </el-col>
        <el-col :lg="24" :md="24" :sm="24" :xl="24">
          <reportTable
            :config="addBuyTable"
            v-loading="loading.addBuy"
            :style="`height:600px;margin-top:0px;`"
            class="analysis"
          >
            <el-table-column prop="cartCnt" :label="$t('performance-board::addBuy::table_goodsOne')" min-width="150px">
              <template slot-scope="scope">
                <div class="prodinfo--table__imgTd">
                  <el-popover placement="top-start" trigger="hover">
                    <ZImg :src="scope.row.imgUrl" style="width: 250px; height: 250px"></ZImg>
                    <ZImg
                      :src="scope.row.imgUrl"
                      style="width: 60px; height: 60px"
                      @click="handleToDetail(scope.row.spu)"
                      slot="reference"
                    ></ZImg>
                  </el-popover>
                  <div>
                    <div>{{ $dataCheck(scope.row.cartCnt) }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="relCartCnt"
              :label="$t('performance-board::addBuy::table_goodsTwo')"
              min-width="150px"
            >
              <template slot-scope="scope">
                <div class="prodinfo--table__imgTd">
                  <el-popover placement="top-start" trigger="hover">
                    <ZImg :src="scope.row.relImgUrl" style="width: 250px; height: 250px"></ZImg>
                    <ZImg
                      :src="scope.row.relImgUrl"
                      style="width: 60px; height: 60px"
                      @click="handleToDetail(scope.row.relSpu)"
                      slot="reference"
                    ></ZImg>
                  </el-popover>
                  <div>
                    <div>{{ $dataCheck(scope.row.relCartCnt) }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="bothCartCnt" :label="$t('performance-board::addBuy::table_both')" min-width="190px">
              <template slot-scope="scope">
                <div class="prodinfo--table__imgTd">
                  <el-popover placement="top-start" trigger="hover">
                    <ZImg :src="scope.row.imgUrl" style="width: 250px; height: 250px"></ZImg>
                    <ZImg
                      :src="scope.row.imgUrl"
                      style="width: 60px; height: 60px"
                      @click="handleToDetail(scope.row.spu)"
                      slot="reference"
                    ></ZImg>
                  </el-popover>
                  +
                  <el-popover placement="top-start" trigger="hover">
                    <ZImg :src="scope.row.relImgUrl" style="width: 250px; height: 250px"></ZImg>
                    <ZImg
                      :src="scope.row.relImgUrl"
                      style="width: 60px; height: 60px"
                      @click="handleToDetail(scope.row.relSpu)"
                      slot="reference"
                    ></ZImg>
                  </el-popover>
                  <div>
                    <div>{{ $dataCheck(scope.row.bothCartCnt) }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="bothCartPer"
              :label="$t('performance-board::addBuy::table_bothRate')"
              min-width="120px"
            >
              <template slot-scope="scope">{{ $dataCheck(scope.row.bothCartPer) }}%</template>
            </el-table-column>
          </reportTable>
        </el-col>
      </el-row>
    </el-card> -->

    <el-row :gutter="20" class="card-content" v-if="tabs === 1">
      <el-col :lg="6" :md="6" :sm="6" :xl="6" v-for="(item, index) in cardOptions" :key="index" class="card-item">
        <dataCard :option="item" v-loading="loading.card"></dataCard>
      </el-col>
    </el-row>

    <template v-if="tabs === 1">
      <el-row :gutter="20">
        <el-col :lg="12" :md="24" :sm="24" :xl="8">
          <reportFunnel
            :config="changeFunnel"
            v-loading="loading.changeFunnel"
            :style="`height: ${reportHeight};`"
            @change="changeFunnelType"
          >
            <template slot="row" slot-scope="{ item, index }">
              <div class="item">{{ item.action }}</div>
              <div class="item">{{ item.clientCnt }}</div>
              <div class="item"></div>
              <div class="item">
                <span class="info-rate" v-if="index !== 0">
                  <div class="rate" style="color: #00ce47" v-if="item.transRateRatio && item.transRateRatio < 0">
                    <i class="iconic-xiajiang iconfont c-icon"></i>
                    <span class="text">
                      {{ $dataCheck(item.transRateRatio) }}
                      <span class="symbol-end">%</span>
                    </span>
                  </div>
                  <div class="rate t" style="color: #ff0022" v-else>
                    <i class="iconic-shangsheng iconfont c-icon"></i>
                    <span class="text">
                      {{ $dataCheck(item.transRateRatio) }}
                      <span class="symbol-end">%</span>
                    </span>
                  </div>
                </span>
              </div>
              <div class="after-item" v-if="index !== 0">{{ item.transRate || '0.00' }}%</div>
            </template>
          </reportFunnel>
        </el-col>

        <el-col :lg="12" :md="24" :sm="24" :xl="8">
          <reportCard
            :config="countryCharts"
            v-loading="loading.country"
            :style="`height: ${reportHeight};`"
          ></reportCard>
        </el-col>

        <el-col :lg="12" :md="24" :sm="24" :xl="8">
          <reportCard
            :config="utmCountryCharts"
            v-loading="loading.utmCountry"
            :style="`height: ${reportHeight};`"
          ></reportCard>
        </el-col>

        <el-col :lg="12" :md="24" :sm="24" :xl="8">
          <reportTable
            :config="utmSourceCharts"
            v-loading="loading.utmSourceCharts"
            :style="`height: ${reportHeight};`"
            @change="changeUtmType"
          >
            <el-table-column
              prop="utm"
              :label="$t('performance-board::data::来源')"
              min-width="120px"
              showOverflowTooltip
            ></el-table-column>
            <el-table-column
              prop="sourceCnt"
              :label="$t('performance-board::data::用户数')"
              min-width="120px"
              showOverflowTooltip
            ></el-table-column>
            <el-table-column
              prop="utmPer"
              :label="$t('performance-board::data::占比')"
              min-width="150px"
              showOverflowTooltip
            >
              <template slot-scope="{ row }">
                <div class="progress-flex">
                  <div class="progress-wrap">
                    <div class="progress-content" :style="{ width: row.utmPer + '%' }"></div>
                  </div>
                  <span>{{ row.utmPer }}</span>
                </div>
              </template>
            </el-table-column>
          </reportTable>
        </el-col>

        <el-col :lg="12" :md="24" :sm="24" :xl="8">
          <reportTable :config="areaSoureCharts" v-loading="loading.areaSoure" :style="`height: ${reportHeight};`">
            <el-table-column
              prop="clientArea"
              :label="$t('performance-board::data::国家')"
              min-width="120px"
              showOverflowTooltip
            ></el-table-column>
            <el-table-column
              prop="clientCnt"
              :label="$t('performance-board::data::用户数')"
              min-width="120px"
              showOverflowTooltip
            ></el-table-column>
            <el-table-column
              prop="clientCntPer"
              :label="$t('performance-board::data::占比')"
              min-width="120px"
              showOverflowTooltip
            >
              <template slot-scope="{ row }">
                <div class="progress-flex">
                  <div class="progress-wrap">
                    <div class="progress-content" :style="{ width: row.clientCntPer + '%' }"></div>
                  </div>
                  <span>{{ row.clientCntPer }}</span>
                </div>
              </template>
            </el-table-column>
          </reportTable>
        </el-col>

        <el-col :lg="12" :md="24" :sm="24" :xl="8">
          <reportTable :config="deviceCharts" v-loading="loading.device" :style="`height: ${reportHeight};`">
            <el-table-column
              prop="deviceType"
              :label="$t('performance-board::data::设备')"
              min-width="120px"
              showOverflowTooltip
            ></el-table-column>
            <el-table-column
              prop="userNum"
              :label="$t('performance-board::data::用户数')"
              min-width="120px"
              showOverflowTooltip
            ></el-table-column>
            <el-table-column
              prop="percent"
              :label="$t('performance-board::data::占比')"
              min-width="120px"
              showOverflowTooltip
            >
              <template slot-scope="{ row }">
                <div class="progress-flex">
                  <div class="progress-wrap">
                    <div class="progress-content" :style="{ width: row.percent + '%' }"></div>
                  </div>
                  <span>{{ row.percent }}</span>
                </div>
              </template>
            </el-table-column>
          </reportTable>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :lg="24" :md="24" :sm="24" :xl="24">
          <reportTable
            @sort-change="sortChange"
            :config="visitorPageTable"
            v-loading="loading.visitorPage"
            :style="`height: ${reportHeight};`"
          >
            <el-table-column
              prop="pageUrl"
              :label="$t('performance-board::data::pageVisitor_pageName')"
              min-width="190px"
              showOverflowTooltip
            ></el-table-column>
            <el-table-column
              prop="pageType"
              :label="$t('performance-board::data::pageVisitor_pageType')"
              min-width="150px"
            ></el-table-column>
            <el-table-column
              prop="visitCnt"
              :label="$t('performance-board::data::pageVisitor_visitorNum')"
              :sortable="'custom'"
              min-width="150px"
            >
              <template slot-scope="scope">{{ $dataCheck(scope.row.visitCnt) }}</template>
            </el-table-column>
            <el-table-column
              prop="clientCnt"
              :label="$t('performance-board::data::pageVisitor_clientCnt')"
              :sortable="'custom'"
              min-width="150px"
            >
              <template slot-scope="scope">{{ $dataCheck(scope.row.clientCnt) }}</template>
            </el-table-column>
            <el-table-column
              prop="viewTimePer"
              :label="$t('performance-board::data::pageVisitor_visitorTime')"
              :sortable="'custom'"
              min-width="190px"
            >
              <template slot-scope="scope">{{ $dataCheck(scope.row.viewTimePer) }}</template>
            </el-table-column>
            <el-table-column
              prop="outRate"
              :label="$t('performance-board::data::pageVisitor_outRate')"
              :sortable="'custom'"
              min-width="150px"
            >
              <template slot-scope="scope">{{ $dataCheck(scope.row.outRate) }}%</template>
            </el-table-column>
          </reportTable>
        </el-col>
      </el-row>
    </template>

    <el-drawer :visible.sync="isShowDetailDrawer" :show-close="false" size="40%">
      <div class="drawer-title" slot="title">{{ $t('performance-board::goods_detail') }}</div>
      <el-scrollbar>
        <detailDrawer :id="spuId" :isShowDetailDrawer="isShowDetailDrawer"></detailDrawer>
      </el-scrollbar>
    </el-drawer>
  </div>
</template>

<script>
import moment from 'moment'
import {
  getPerformanceBoardCount,
  getChangeFunnel,
  getUtmSourceCharts,
  getVisitorAreaSoure,
  getVisitorPageCount,
  getSearchTable,
  getAddBuyTable,
  getIntegrationDevice,
  getClientCountry,
  getUtmCountry,
} from '@/server/data'
import { getShopList } from '@/server/product'
import { pickerOptions } from '@/utils/datepickerConfig'
import setConfig from './setConfig'
import dataCard from '@/components/data-analysis/card'
import reportCard from '@/components/data-analysis/report'
import reportFunnel from '@/components/data-analysis/funnel'
import reportTable from '@/components/data-analysis/table'
import detailDrawer from '@/views/commodity-center/products/product-info/detail/drawer.vue'
export default {
  components: {
    dataCard,
    reportCard,
    reportTable,
    reportFunnel,
    detailDrawer,
  },
  mixins: [setConfig],
  data() {
    return {
      tabs: 1,
      pickerOptions: {
        ...pickerOptions,
        disabledDate: time => {
          return time.getTime() >= Date.parse(new Date())
        },
      },
      date: [moment(), moment()],
      params: {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      },
      utmType: 'utm_source',
      transType: '1',
      selectedShop: '',
      shopList: [{ shopName: this.$t('system::common::select_all'), shopId: '' }],
      cardOptions: {},
      reportHeight: '400px',
      changeFunnel: [],
      utmSourceCharts: [],
      areaSoureCharts: [],
      visitorPageTable: [],
      searchTable: [],
      addBuyTable: [],
      loading: {
        card: false,
        changeFunnel: false,
        utmSourceCharts: false,
        areaSoure: false,
        visitorPage: false,
        search: false,
        addBuy: false,
        device: false,
        country: false,
        utmCountry: false,
      },
      sortData: { visitCnt: null, viewTimePer: null, clientCnt: null },
      isShowDetailDrawer: false,
      spuId: '',
      deviceCharts: {},
      countryCharts: {},
      utmCountryCharts: {},
    }
  },
  async mounted() {
    this.cardOptions = this.setCountList({})
    await this.getShopData()
    this.getAllData()
  },
  methods: {
    async getShopData() {
      const { data } = await getShopList({ mallType: 1 })
      if (data.code === this.$code && data.data) {
        this.shopList = [...this.shopList, ...data.data]
      }
    },
    getAllData() {
      if (this.tabs === 1) {
        this.getCount()
        this.getChangeFunnel()
        this.getUtmSourceCharts()
        this.getVisitorAreaSoure()
        this.getVisitorPageCount()
        this.getIntegrationDevice()
        this.getClientCountry()
        this.getUtmCountry()
      } else if (this.tabs === 2) {
        this.getSearchTable()
      } else if (this.tabs === 3) {
        this.getAddBuyTable()
      }
    },
    changeShop(type) {
      if (type) {
        this.tabs = type
      }
      this.getAllData()
    },
    changeUtmType(val) {
      this.utmType = val
      this.getUtmSourceCharts()
    },
    changeFunnelType(val) {
      this.transType = val
      this.getChangeFunnel()
    },
    async getCount() {
      let obj = {
        ...this.params,
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.card = true
      const { data } = await getPerformanceBoardCount(obj)
      if (data.code === this.$code) {
        this.cardOptions = this.setCountList(data.data.datas[0] || {}, this.params)
      }
      this.loading.card = false
    },
    async getChangeFunnel() {
      let obj = {
        ...this.params,
        transType: this.transType,
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.changeFunnel = true
      const { data } = await getChangeFunnel(obj, this.transType)
      if (data.code === this.$code) {
        const list = Array.isArray(data.data.datas) ? data.data.datas : []
        this.changeFunnel = this.setChangeFunnelConfig(list, this.transType)
      }
      this.loading.changeFunnel = false
    },
    async getUtmSourceCharts() {
      let obj = {
        ...this.params,
        utmType: this.utmType,
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.utmSourceCharts = true
      const { data } = await getUtmSourceCharts(obj)
      if (data.code === this.$code) {
        const list = Array.isArray(data.data.datas) ? data.data.datas : []
        this.utmSourceCharts = this.setUtmSourceTable(list, this.utmType)
      }
      this.loading.utmSourceCharts = false
    },
    async getVisitorAreaSoure() {
      let obj = {
        ...this.params,
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.areaSoure = true
      const { data } = await getVisitorAreaSoure(obj)
      if (data.code === this.$code) {
        const list = Array.isArray(data.data.datas) ? data.data.datas : []
        this.areaSoureCharts = this.setAreaSoureTable(list)
      }
      this.loading.areaSoure = false
    },
    async getVisitorPageCount() {
      let orderName = []
      for (let i in this.sortData) {
        if (this.sortData[i]) {
          orderName.push([i, this.sortData[i]])
        }
      }
      let obj = {
        ...this.params,
        orderName,
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.visitorPage = true
      const { data } = await getVisitorPageCount(obj)
      if (data.code === this.$code) {
        const list = Array.isArray(data.data.datas) ? data.data.datas : []
        this.visitorPageTable = this.setVisitorPageConfig(list)
      }
      this.loading.visitorPage = false
    },
    async getSearchTable() {
      let obj = {
        ...this.params,
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.search = true
      const { data } = await getSearchTable(obj)
      if (data.code === this.$code) {
        const list = Array.isArray(data.data.datas) ? data.data.datas : []
        this.searchTable = this.setSearchTableConfig(list)
      }
      this.loading.search = false
    },
    async getAddBuyTable() {
      let obj = {
        ...this.params,
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.addBuy = true
      const { data } = await getAddBuyTable(obj)
      if (data.code === this.$code) {
        const list = Array.isArray(data.data.datas) ? data.data.datas : []
        this.addBuyTable = this.setAddBuyTableConfig(list)
      }
      this.loading.addBuy = false
    },
    handlerDateChange(date) {
      this.params.startDate = moment(date[0]).format('YYYY-MM-DD')
      this.params.endDate = moment(date[1]).format('YYYY-MM-DD')
      this.getAllData()
    },
    handleToDetail(id) {
      if (id) {
        this.isShowDetailDrawer = true
        this.spuId = id
      }
    },
    async getIntegrationDevice() {
      let obj = {
        ...this.params,
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.device = true
      const { data } = await getIntegrationDevice(obj)
      if (data.code === this.$code) {
        const list = Array.isArray(data.data.datas) ? data.data.datas : []
        this.deviceCharts = this.setIntegrationDevice(list)
      }
      this.loading.device = false
    },
    async getClientCountry() {
      let obj = {
        ...this.params,
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.country = true
      const { data } = await getClientCountry(obj)
      if (data.code === this.$code) {
        const list = Array.isArray(data.data.datas) ? data.data.datas : []
        this.countryCharts = this.setClientCountry(list)
      }
      this.loading.country = false
    },
    async getUtmCountry() {
      let obj = {
        ...this.params,
      }
      if (this.selectedShop) obj = { shopId: Number(this.selectedShop), ...obj }
      this.loading.utmCountry = true
      const { data } = await getUtmCountry(obj)
      if (data.code === this.$code) {
        const list = Array.isArray(data.data.datas) ? data.data.datas : []
        this.utmCountryCharts = this.setUtmCountry(list)
      }
      this.loading.utmCountry = false
    },
    sortChange(data) {
      const type = { descending: 'desc', ascending: 'asc' }
      this.sortData[data.prop] = type[data.order] || null
      for (let i in this.sortData) {
        if (i === data.prop) {
          this.sortData[data.prop] = type[data.order] || null
        } else {
          this.sortData[i] = null
        }
      }
      this.getVisitorPageCount()
    },
  },
}
</script>

<style lang="scss" scoped>
.data-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /deep/ .el-form-item {
    margin-bottom: 0;
  }
}
.header-tip {
  color: #999;
  font-size: 14px;
}
.card-content {
  margin-top: 10px;
}
.card-content__total {
  position: absolute;
  font-size: 16px;
  margin-top: 16px;
}
.date-label {
  display: flex;
  justify-content: center;
  align-items: center;
}
.prodinfo--table {
  &__imgTd {
    display: flex;
    align-items: center;
    img {
      width: 50px;
      height: 50px;
      margin: 0 10px;
    }
  }
  /deep/ .el-table td {
    padding: 0;
  }
  .tag-wrap {
    display: flex;
    align-items: center;
  }
}
/deep/.el-drawer__body {
  height: 100%;
  overflow: auto;
}
/deep/.el-drawer__header {
  align-items: center;
  color: #010517;
  display: flex;
  margin-bottom: 0px;
  padding: 10px 10px 0;
}
.analysis {
  /deep/.el-card__body {
    padding: 0;
    padding-right: 1px;
  }
}
.drawer-title {
  font-size: 16px;
  border-bottom: 1px solid #ebeef5;
  padding: 10px 0;
}
.progress-flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .progress-wrap {
    width: 100px;
    height: 16px;
    background-color: rgb(230, 238, 255);
    border-radius: 3px;
    overflow: hidden;
    position: relative;
    margin-right: 5px;
    .progress-content {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      background-color: rgb(24, 144, 255);
    }
  }
}
</style>
